// extracted by mini-css-extract-plugin
module.exports = {"footer":"MenuFooter_footer__20c1B","collapsed":"MenuFooter_collapsed__1YyQo","footerText":"MenuFooter_footerText__1yll-"};